import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import * as fromAuth from '../store/auth';
import * as fromUserProfile from 'src/app/modules/core/store/user-profile';
import * as fromRouting from 'src/app/modules/core/store/routing';
import { Store } from '@ngrx/store';
import { State } from '../store/auth/auth.reducer';

@Component({
    selector: 'topo-change-organization',
    templateUrl: './change-organization.component.html',
    styleUrls: ['./change-organization.component.scss'],
    standalone: false
})
export class ChangeOrganizationComponent implements OnInit, OnDestroy {
  public destroy$ = new Subject<void>();
  private newToken: fromAuth.AuthToken = null;

  constructor(private router: Router, private store: Store<State>) { 

    const currentNavigation: any = router.getCurrentNavigation();
    const state = currentNavigation?.extras?.state;

    if(!!state?.newToken) {
      this.newToken = state?.newToken;
    }
  }

  ngOnInit(): void {

    if(!this.newToken) {
      return;
    }

    this.store.dispatch(fromAuth.changingOrganization({token: this.newToken}));    
    this.store.dispatch(fromRouting.go({routeData: { path: ['cop']}}));
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
